import React, {useState} from "react";
import selfTheme from "./theme.module.scss";
import {observer} from "mobx-react";
import {Label, ButtonsGroup, GroupButton} from "@vidazoo/ui-kit";
import clsx from "clsx";
import {ChartType, ChartTypesWithImg} from '../../enums/ChartType';

export interface IChartTypesSelectProps {
    onSelectType: (type: ChartType) => void;
    selectedType: ChartType;
    disabled?: boolean;
    appearance?: 'default' | 'classic';
}

export default observer(function ChartTypesSelect({onSelectType, selectedType, disabled, appearance}: IChartTypesSelectProps) {

    const [hover, setHover] = useState("")

    if (appearance === 'classic') {
        const types = disabled ? ChartTypesWithImg.filter(type => type.value === selectedType) : ChartTypesWithImg;
        return <div className={selfTheme.classic} data-chart-types>
            {types.map(type => <button type="button" key={type.value}
                aria-label={type.label} aria-pressed={type.value === selectedType} disabled={disabled}
                className={clsx(selfTheme.card, {[selfTheme.selected]: type.value === selectedType})}
                onClick={() => onSelectType(type.value)}>
                <Label weight={500} spacing={1} size={14}>{type.label}</Label>
                <div className={selfTheme.preview} style={{backgroundImage: `url(${type.image})`}}/>
            </button>)}
        </div>;
    }

    return (
        <div className={selfTheme.container}>
            <ButtonsGroup dark active={selectedType} onChange={(item: ChartType) => onSelectType(item)}>
                {ChartTypesWithImg.map((type) => {
                    const classNames = clsx(selfTheme.type, {
                        [selfTheme.selected]: type.value === selectedType,
                    });
                    const imageClassNames = clsx(selfTheme.image, {
                        [selfTheme.imageHover]: type.value === hover,
                    });

                    return (
                        <GroupButton key={type.value} className={classNames} onMouseOver={() => setHover(type.value)} onMouseLeave={() => setHover("")} name={type.value}>
                            <div className={imageClassNames} style={{backgroundImage: `url(${type.image})`}}/>
                            {type.label}
                        </GroupButton>
                    );
                })}
            </ButtonsGroup>
        </div>
    );
});

